import React from 'react';

class CompanySelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCompany: props.companies && props.companies.length && props.companies[0].id
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companies && nextProps.companies.length) {
            this.setState({ selectedCompany: nextProps.companies[0].id });
        }
    }

    render() {
        const { companies, addCompany } = this.props;

        return (
            <div className='company-selector-holder'>
                <div className='company-selector-label'>Select company</div>
                <select onChange={(e) => this.setState({ selectedCompany: parseInt(e.target.value) })} value={this.state.selectedCompany}>
                    { companies.length ? companies.map(item =>
                        <option key={'compsel_'+item.id} value={item.id}>{item.name}</option>
                    ) : null }
                </select>
                <button onClick={() => addCompany(this.state.selectedCompany)} className='button'>Add</button>
            </div>
        )
    }
}

export default CompanySelector;


// WEBPACK FOOTER //
// ./source/components/CompanySelector.js